import RouteView from "../../navigation/RouteView";
import CreateProjectPage from "./CreateProjectPage";
import { createProjectRoute } from "./navigation";

export default function CreateProjectNavigator() {
    return <RouteView route={createProjectRoute} component={CreateProjectPage} />;
}
